/** @format */

import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { useKey } from "hooks";


const config = {
  baseURL: process.env.REACT_APP_BASE_URI_AI,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
};

const AIAxios = axios.create(config);
AIAxios.interceptors.request.use(
  async (req: any) => {
    // const { getKey } = useKey();
    // const token = getKey(KEY_CONTEXT.AUTH_TOKEN);

    // if (token) {
    //   req.headers.Authorization = `Bearer ${token}`;
    // }

    return req;
  },
  (err: any) => Promise.reject(err)
);

AIAxios.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  async (err: AxiosError) => {
    const originalRequest = err.config as InternalAxiosRequestConfig & {
      _retry?: boolean;
    };
    if ([401, 403].includes(err.response?.status) && !originalRequest._retry) {
      originalRequest._retry = true;
      const { logout403 } = useKey();
      await logout403();

    }
    return Promise.reject(((err || {}).response || {}).data);
  }
);

export default AIAxios;

